import {inject, injectable} from "inversify";
import chance from "@/modules/base/services/chance";
import {BeforeTrainingProgressEvent} from "@/modules/training/events/BeforeTrainingProgressEvent";
import {AfterTrainingProgressEvent} from "@/modules/training/events/AfterTrainingProgressEvent";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Player} from "@/modules/team/entity";

@injectable()
export class TrainingEvaluator {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  can(player: Player) {
    // +1 is to avoid player to have 0 energy, which will result in error
    return player.energy > this.configRepository.get('training.energyReduction')(player) + 1;
  }

  async evaluate(player: Player): Promise<void> {
    const randomRange = this.configRepository.get('training.randomPercentRange');

    let talentProgress = player.talent * this.configRepository.get('training.talentFactor');
    talentProgress *= chance.integer({min: 100 - randomRange / 2, max: 100 + randomRange / 2}) / 100;

    const totalProgress = talentProgress;
    const energyReduction = this.configRepository.get('training.energyReduction')(player);

    await this.em.emitAsync(new BeforeTrainingProgressEvent(player, totalProgress, energyReduction));

    player.skill += totalProgress;
    player.energy = Math.max(0, player.energy - energyReduction);
    await player.save();

    await this.em.emitAsync(new AfterTrainingProgressEvent(player, totalProgress, energyReduction));

    console.debug(`Player ${player.name} training completed`, {talentProgress, player});
  }
}
